import { render } from "./TheContact.vue?vue&type=template&id=7895bdba"
const script = {}

import "./TheContact.vue?vue&type=style&index=0&id=7895bdba&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_webpack@5.109.0_clean-css@5.3.3_c_eab102a9d91ac3d44b724d4105ef1f5b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__